import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { ApiService } from '../service/api.service';
import { UtilService, PagePointer } from '../service/util.service';
import { Constants } from '../constants/constants';
import { DatePipe } from '@angular/common';
import { ToastService } from '../service/toast.service';
import { SearchResultsComponent } from '../search-results/search-results.component';
import { SearchDataService } from '../service/search-data.service';


@Component({
  selector: 'app-usage',
  templateUrl: './usage.component.html',
  styleUrls: ['./usage.component.scss'],
  providers: [DatePipe]
})
export class UsageComponent implements OnInit {

  usageSelectionOption = ["Current Billing Cycle", "Previous Billing Cycle", "Date Range"];
  sortOption = ["ByDate", "ByVin"];
  sortType = ["DESCENDING", "ASCENDING"];
  columns = ["Date Time", "Correlation Id", "VIN", "Location", "Service Name", "Request Type", "Status"];
  selectedSortColumn = this.columns[0];
  selectedSortType = this.sortType[0];
  isDateRangeSelected: boolean = false;
  selectedFromDate = new Date();
  selectedToDate = new Date();
  today = new Date();
  selectedSelectionRange: string;

  usageData: Array<any> = new Array<any>();
  usageUiData: Array<any> = new Array<any>();
  accountCategory: string;

  fleetId: String = null;
  accountType: string;
  account: any = {};
  size:number = 200;
  usagePageInfo: any;
  fromDate : string;
  toDate: string;
  pagePointer = PagePointer;
  flag: PagePointer;

  //Search result storage variable
  @ViewChild('searchResult') searchResult:SearchResultsComponent;
  searchedUsageList: Array<any>;
  selectedSearchItemForView: string;
  showSearchResult: boolean = false;
  isSearchResult: boolean = false;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private datePipe: DatePipe, private utilService: UtilService, private toast: ToastService, private searchService: SearchDataService) { }

  ngOnInit() {
    this.processSearchResult();
    this.accountCategory = this.apiService.accountDetail.category;
    // this.usageData = this.usage.getUsage().transactions;
    this.selectedSelectionRange = this.usageSelectionOption[0];
    this.onUsageRangeChange(this.usageSelectionOption[0]);
  }

  ngOnDestroy() {
    this.searchService.resetPreviousSearchResult();
  }

  private processSearchResult() {
    this.searchService.searchedData.subscribe(data => {
      this.searchedUsageList = this.searchService.getSearchedDataForType(Constants.SERVICE_USAGE);
      if (this.searchedUsageList && this.searchedUsageList.length > 0) {
        this.showSearchResult = true;
      }
      else {
        this.showSearchResult = false;
      }
    });
  }

  getServiceUsageReportsBetweenDates(fromDate, toDate) {
    this.usageData = [];
    this.utilService.showSpinner();
    this.apiService.getServiceUsageReportsBetweenDates(fromDate, toDate).then((data) => {
      this.utilService.hideSpinner();
      this.usageData = data.transactions;
      console.log("Usage service data::", data);
      this.prepareUIData();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getServiceUsageReportsBetweenDates(fromDate, toDate);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  prepareUIData() {
    if (this.usageData == null) return;
    // if(sortOption == this.sortOption[0]) {
    this.sortByDate(this.sortType[0]);
    // }

  }

  sortByDate(sortType: string) {
    let that = this;
    this.usageUiData = this.usageData.sort(function (a, b) {
      if (sortType == that.sortType[0]) {
        return <any>new Date(b.requestTime) - <any>new Date(a.requestTime);
      } else {
        return <any>new Date(a.requestTime) - <any>new Date(b.requestTime);
      }
    });
  }

  onSortByDateClick() {
    console.log("sort by date clicked::", this.selectedSortType);
    if(this.selectedSortColumn == undefined || this.selectedSortColumn == null || this.selectedSortColumn != this.columns[0]) {
      this.selectedSortType = null;
    }
    this.selectedSortColumn = this.columns[0];

    if (this.selectedSortType == this.sortType[0]) {
      this.sortByDate(this.sortType[1]);
      this.selectedSortType = this.sortType[1];
    } else {
      this.sortByDate(this.sortType[0]);
      this.selectedSortType = this.sortType[0];
    }
  }

  sortStringVal(sortType: string, fieldName: string) {
    let that = this;
    this.usageUiData = this.usageData.sort(function (a, b) {
      var val1 = "";
      var val2 = "";
      if (a[fieldName] != undefined && a[fieldName] != null) {
        val1 = a[fieldName].toLowerCase();
      }
      if (b[fieldName] != undefined && b[fieldName] != null) {
        val2 = b[fieldName].toLowerCase();
      }
      if (sortType == that.sortType[0]) {
        if (val1 < val2) return -1;
        if (val1 > val2) return 1;
        return 0;
      } else {
        if (val1 > val2) return -1;
        if (val1 < val2) return 1;
        return 0;
      }
    });
  }

  sortByAddress(sortType: string) {
    let that = this;
    this.usageUiData = this.usageData.sort(function (a, b) {
      var val1 = "";
      var val2 = "";
      if (a.facilityLocation != null && a.facilityLocation.address != null && a.facilityLocation.address.city != null) {
        val1 = a.facilityLocation.address.city.toLowerCase();
      }
      if (b.facilityLocation != null && b.facilityLocation.address != null && b.facilityLocation.address.city != null) {
        val2 = b.facilityLocation.address.city.toLowerCase();
      }

      if (sortType == that.sortType[0]) {
        if (val1 < val2) return -1;
        if (val1 > val2) return 1;
        return 0;
      } else {
        if (val1 > val2) return -1;
        if (val1 < val2) return 1;
        return 0;
      }
    });
  }

  onSortByVinClick() {
    console.log("sort by vin clicked::", this.selectedSortType);
    if(this.selectedSortColumn == undefined || this.selectedSortColumn == null || this.selectedSortColumn != this.columns[2]) {
      this.selectedSortType = null;
    }
    this.selectedSortColumn = this.columns[2];

    if (this.selectedSortType == this.sortType[0]) {
      this.selectedSortType = this.sortType[1];
      this.sortStringVal(this.sortType[1], "vin");
    } else {
      this.selectedSortType = this.sortType[0];
      this.sortStringVal(this.sortType[0], "vin");
    }
  }

  onSortByCorrelationIdClick() {
    console.log("sort by correlation id clicked::", this.selectedSortType);
    if(this.selectedSortColumn == undefined || this.selectedSortColumn == null || this.selectedSortColumn != this.columns[1]) {
      this.selectedSortType = null;
    }
    this.selectedSortColumn = this.columns[1];

    if (this.selectedSortType == this.sortType[0]) {
      this.selectedSortType = this.sortType[1];
      this.sortStringVal(this.sortType[1], "correlationId");
    } else {
      this.selectedSortType = this.sortType[0];
      this.sortStringVal(this.sortType[0], "correlationId");
    }
  }

  onSortByServiceNameClick() {
    console.log("sort by service name clicked::", this.selectedSortType);
    if(this.selectedSortColumn == undefined || this.selectedSortColumn == null || this.selectedSortColumn != this.columns[4]) {
      this.selectedSortType = null;
    }
    this.selectedSortColumn = this.columns[4];

    if (this.selectedSortType == this.sortType[0]) {
      this.selectedSortType = this.sortType[1];
      this.sortStringVal(this.sortType[1], "serviceName");
    } else {
      this.selectedSortType = this.sortType[0];
      this.sortStringVal(this.sortType[0], "serviceName");
    }
  }

  onSortByRequestTypeClick() {
    console.log("sort by request type clicked::", this.selectedSortType);
    if(this.selectedSortColumn == undefined || this.selectedSortColumn == null || this.selectedSortColumn != this.columns[5]) {
      this.selectedSortType = null;
    }
    this.selectedSortColumn = this.columns[5];

    if (this.selectedSortType == this.sortType[0]) {
      this.sortStringVal(this.sortType[1], "operation");
      this.selectedSortType = this.sortType[1];
    } else {
      this.sortStringVal(this.sortType[0], "operation");
      this.selectedSortType = this.sortType[0];
    }
  }

  onSortByLocationClick() {
    console.log("sort by Location clicked::", this.selectedSortType);
    if(this.selectedSortColumn == undefined || this.selectedSortColumn == null || this.selectedSortColumn != this.columns[3]) {
      this.selectedSortType = null;
    }
    this.selectedSortColumn = this.columns[3];

    if (this.selectedSortType == this.sortType[0]) {
      this.sortByAddress(this.sortType[1]);
      this.selectedSortType = this.sortType[1];
    } else {
      this.sortByAddress(this.sortType[0]);
      this.selectedSortType = this.sortType[0];
    }
  }

  onSortByStatusClick() {
    console.log("sort by Status clicked::", this.selectedSortType);
    if(this.selectedSortColumn == undefined || this.selectedSortColumn == null || this.selectedSortColumn != this.columns[6]) {
      this.selectedSortType = null;
    }
    this.selectedSortColumn = this.columns[6];

    if (this.selectedSortType == this.sortType[0]) {
      this.sortStringVal(this.sortType[1], "operationStatus");
      this.selectedSortType = this.sortType[1];
    } else {
      this.sortStringVal(this.sortType[0], "operationStatus");
      this.selectedSortType = this.sortType[0];
    }
  }

  onUsageRangeChange(sortOption: string) {
    this.selectedSelectionRange = sortOption;
    if (this.selectedSelectionRange == this.usageSelectionOption[0]) {
      this.isDateRangeSelected = false;
      var date = new Date(), y = date.getFullYear(), m = date.getMonth();
      this.selectedFromDate = new Date(y, m, 1);
      this.selectedToDate = date;
      this.getDateWiseServiceUsageBetweenDates();
    } else if (this.selectedSelectionRange == this.usageSelectionOption[2]) {
      this.isDateRangeSelected = true;
    } else if (this.selectedSelectionRange == this.usageSelectionOption[1]) {
      this.isDateRangeSelected = false;
      var d = new Date();
      d.setMonth(d.getMonth() - 1);
      d.setDate(1);
      d.setHours(0);
      this.selectedFromDate = d;
      this.selectedToDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
      console.log("from date::", this.selectedFromDate, ":: To date::", this.selectedToDate);
      this.getDateWiseServiceUsageBetweenDates();
    }

    this.prepareUIData();
  }

  getDateWiseServiceUsageBetweenDates() {
    this.fromDate = this.datePipe.transform(this.selectedFromDate, 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(this.selectedToDate, 'yyyy-MM-dd');
    console.log("from date::", this.fromDate, ":: To date::", this.toDate);
    // this.getServiceUsageReportsBetweenDates(this.fromDate, this.toDate);
    this.getServiceUsageReportsByPage();
  }

  getServiceUsageReportsByPage() {
    this.usageData = [];
    this.utilService.showSpinner();
    this.apiService.getServiceUsageReportsWithPageSize(this.fleetId, this.fromDate, this.toDate, this.size).then((data) => {
      this.utilService.hideSpinner();
      this.usagePageInfo = data;
      this.usageData = data.transactions;
      console.log("Usage service data::", data);
      this.prepareUIData();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getServiceUsageReportsByPage();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getPreviousPage() {
    // this.usageData = [];
    var pointer = this.pagePointer.PREVIOUS;
    var index = this.usagePageInfo.prev;
    this.getPageWiseServiceUsageData(pointer, index);
  }

  getNextPage() {
    var pointer = this.pagePointer.NEXT;
    var index = this.usagePageInfo.next;
    this.getPageWiseServiceUsageData(pointer, index);
  }

  getPageWiseServiceUsageData(pointer, index) {
    this.utilService.showSpinner();
    this.apiService.getServiceUsageReportsbyPageIndex(this.fleetId, this.fromDate, this.toDate, this.size, pointer, index).then((data) => {
      this.utilService.hideSpinner();
      console.log("Usage service data::", data);
      if(data.transactions && data.transactions.length>0) {
        this.usagePageInfo = data;
        this.usageData = data.transactions;
        this.prepareUIData();
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getPreviousPage();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

}
